/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Meta_DescInputs */

const en_st_meta_desc = /** @type {(inputs: St_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn a verified PRD into a bilingual proposal PDF, give the client a progress page backed by evidence, and hand over one ZIP at the end.`)
};

const id_st_meta_desc = /** @type {(inputs: St_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubah PRD terverifikasi menjadi proposal PDF dwibahasa, beri klien halaman progres berbukti, dan serahkan satu ZIP di akhir proyek.`)
};

/**
* | output |
* | --- |
* | "Turn a verified PRD into a bilingual proposal PDF, give the client a progress page backed by evidence, and hand over one ZIP at the end." |
*
* @param {St_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_meta_desc = /** @type {((inputs?: St_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_meta_desc(inputs)
	return en_st_meta_desc(inputs)
});